<template>
	<div class="flex-grow-1">
		<GmapMap ref="routeMap"
			:center="route.terminals.origin"
			:zoom="10"
			map-type-id="roadmap"
			style="height:100%"
			:options="mapOptions"
		>
	<!-- disabled for now; these markers are always a problem: lots of database calls. where should the pin be? etc.
	 		<GmapMarker
			 	v-for="(m, index) in this.route.extra_checkins_markers"
				v-if="m.position"
			    :key="index"			    
			    :position="m.position"
			    :clickable="true"
			    :draggable="false"
			    @click="center=m.position"
			/> -->
		</GmapMap>
	</div>
</template>

<script >

	import { mapState } from 'vuex';

	export default {
	    props: ['route', 'data_loaded'],

	    data() {
	    	return {
				markers: [], //extra checkins
				//optimizeWaypoints: true,

				mapOptions: {
					disableDefaultUI : true,
					streetViewControl: null,
					zoomControl: null,
					rotateControl: true,
				},

				measures: {
					distance: [],
					duration: [],
				},

				error: false,
	    	}
	    },
		
		created() {
		},

		mounted() {
			if (this.data_loaded == true) {
				this.setMap();
				this.setMapOptions();
			}

			this.$root.$on('rebuild_map', () => {
				Vue.nextTick(() => {
					this.reMap();
				});
			});			
	    },

	    computed: {
	    	...mapState(['config'])
	    },

		methods: {
			reMap() {
				this.directionsDisplay.setMap(null);
				this.getDirections();
			},

			setMap() {
				//need to wrap in a promise to make directions show on load
				this.$refs.routeMap.$mapPromise.then(() => {
					this.getDirections(); 
			    })		
			},

			setMapOptions() {
				if (this.config.layout === 'mobile') {
					this.mapOptions.streetViewControl = false;
					this.mapOptions.zoomControl = false;
				} else {
					this.mapOptions.streetViewControl = true;
					this.mapOptions.zoomControl = true;
				}
			},

		    getDirections () {
		    	let measures = this.measures;
		    	measures.distance.length = 0;
		    	measures.duration.length = 0;

				this.directionsService = new google.maps.DirectionsService();
				this.directionsDisplay = new google.maps.DirectionsRenderer();
				// keep this here for later. It works, but it applies to all markers. need to customize per waypoint.
				// this.directionsDisplay = new google.maps.DirectionsRenderer({
				//     markerOptions: {
				// 		icon: { //base icon styling
				// 		    path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
				// 		    fillColor: '#EE2742',
				// 		    fillOpacity: 1,
				// 		    strokeWeight: 1.25,
				// 		    strokeColor: 'rgba(255,255,255,.8)',				    
				// 		    size: {width: 24, height: 24, f: 'px', b: 'px'},
				// 		    anchor: {x: 12, y: 24, },
				// 		    scale: 1.5
				// 		},
				//     },
				// });		      
				this.directionsDisplay.setMap(this.$refs.routeMap.$mapObject);
				
				var vm = this;
				vm.directionsService.route({
					origin: this.route.terminals.origin, // from route model
					destination: this.route.terminals.destination,
					waypoints: this.route.waypoints,
					travelMode: google.maps.DirectionsTravelMode.DRIVING,
					optimizeWaypoints: true,
				}, function (response, status) {
					if (status === 'OK') {
						vm.directionsDisplay.setDirections(response) // draws the polygon to the map

						response.routes[0].legs.forEach(leg => { //get some route metrics and send back to vue
							measures.distance.push(leg.distance.value);
							measures.duration.push(leg.duration.value);
						});
						vm.$root.$emit('route_changed', measures);	
						vm.$root.$emit('route_order', response.routes[0].waypoint_order);
						vm.$root.$emit('route_steps', response.routes[0].legs);	

					} else {
						vm.$root.$emit('route_error', status);
						console.log('Directions request failed due to ' + status)
					}
				});
		    },

		},

		watch: {
			config: {
				handler() {
					this.setMapOptions();
				},
				deep: true,
			},
		},
	}
</script>